import React, { Dispatch, SetStateAction, useEffect, useState } from "react"
import { PROVIDER_TYPE } from "lib/types/common"
import { Provider } from "lib/types/generated/graphql-types"

import { Container, EmptyList, Wrapper } from "components/Ui/Table/Shared.styled"

import ErrorMessage from "components/Ui/Messages/ErrorMessage"
import TableBlurLoading from "components/Ui/Table/TableBlurLoading"
import { getLoadingRow, IngridTableRow } from "./IngridConfigTableRow"

import { ReactComponent as IngridLogo } from "images/providers/icons/ingrid.svg"
import TableHeader from "../../Ui/Table/TableHeader"

type Props = {
  providers: Provider[]
  error: object | undefined
  setIngridConfigId?: Dispatch<SetStateAction<string>>
  loading: boolean
}

export const IngridConfigTable = ({ providers, setIngridConfigId, error, loading }: Props) => {
  const [ingridProviders, setIngridProviders] = useState<Provider[]>([])

  useEffect(() => {
    if (providers) {
      setIngridProviders(providers?.filter((provider) => provider.type === PROVIDER_TYPE.INGRID))
    }
  }, [providers])

  const tableHeader = (
    <TableHeader iconHeader={true}>
      <div>Identifier</div>
      <div className="hideOnSmallScreens">Base URL</div>
      <div className="hideOnSmallScreens hideOnMediumScreens">Created</div>
      <div className="hideOnSmallScreens hideOnMediumScreens">Updated</div>
    </TableHeader>
  )

  if (loading)
    return <TableBlurLoading numberOfRows={4} tableHeader={tableHeader} rows={getLoadingRow()} />

  if (ingridProviders?.length < 1)
    return (
      <EmptyList>
        <IngridLogo />
        <p> No configurations added</p>
      </EmptyList>
    )

  return (
    <Wrapper>
      <Container>
        {error && (
          <ErrorMessage
            showRefreshButton
            message={
              <>
                Error loading Ingrid settings. Try refreshing the page, or contact{" "}
                <a href="mailto:support@brinkcommerce.com">support</a>.
              </>
            }
          />
        )}
        {tableHeader}
        {[...ingridProviders].map((ingridProvider) => (
          <IngridTableRow
            key={ingridProvider.id}
            id={ingridProvider.id}
            setIngridConfigId={setIngridConfigId}
          />
        ))}
      </Container>
    </Wrapper>
  )
}
